// Convert string to lowercase if it is a string
export const lowerIfString = (value: any) =>
	typeof value === "string" ? value.toLowerCase() : value;

// Capitalize the first letter of the string
export const capitalizeFirstLetter = (string: any) => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};

// convert snake_case to title case
export const convertSnakeCaseToTitleCase = (string: any) => {
	return string
		.replace(/_/g, " ")
		.replace(/\b\w/g, (char: any) => char.toUpperCase());
};

// Format the sentence to capitalize the first letter of the sentence and the words after a full stop
export const formatSentence = (string: any) => {
	// Remove extra white spaces and split the sentence into an array of words
	let words = string.trim().split(/\s+/);

	let formattedSentence = "";
	for (let i = 0; i < words.length; i++) {
		// Capitalize the first word and words after a full stop
		const lastChar = words[i - 1]
			? words[i - 1].charAt(words[i - 1].length - 1)
			: "";
		const terminators = [".", "!", "?", ";"]; // You can add more sentence terminators here

		if (i === 0 || terminators.includes(lastChar)) {
			formattedSentence +=
				words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
		} else {
			formattedSentence += words[i].toLowerCase();
		}

		// Add space between words, except for the last word
		if (i !== words.length - 1) {
			formattedSentence += " ";
		}
	}

	// Add a period at the end if it's not already there
	if (!formattedSentence.endsWith(".")) {
		formattedSentence += ".";
	}

	return formattedSentence;
};
